module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_vm._m(0), _vm._v(" "), _c('el-nav')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/20180102/logo@2x.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6652223d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 298
// module chunks = 1